export default "__VITE_ASSET__DjhwRoY4__"